import env from '../env';

export default {
	GET_LOCATIONS: `${env.API_VIEWER}ExternalView/CustomerSearchAutoComplete`,
};
